import { IonAlert, IonLabel } from "@ionic/react";
import _ from "lodash";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { CONSTANTS } from "../../../../constants/callcentral.constants";
import { menuSettingsConstants, ONmenuSettingsConstants } from "../../../../constants/MenuSettingsObjects";
import { emsMenuSettingsConstants } from "../../../../constants/MenuSettingsObjects";
import { utilService } from "../../../../services";
import { AuthService } from "../../../../services/authService";
import { loggedInUserService } from "../../../../services/loggedInUser.service";
import About from "../About/About";
import AvailabilityList from "../AvailabilityList/AvailabilityList";
import ContactNum from "../ContactNum/ContactNum";
// import { contactDetailsInputModel, displayContactContainerModel } from "../ContactNum/Models/ContactNum.model";
import Help from "../Help/Help";
import MyProfile from "../MyProfile/MyProfile";
import ScheduleSync from "../ScheduleSync/ScheduleSync";
import Settings from "../Settings/Settings";
import { settingsService } from "../Settings/Settings.service";
import "./MenuSettingsList.scss";
import { useTranslation } from "react-i18next";
import i18n from "../../../../locales/i18n/i18n";

interface Props {
  isActive: () => void;
  isInactive: () => void;
  isMyContactNumberClicked: boolean;
}

const MenuSettingsList: React.FC<Props> = (props) => {
  const [isMenuSettingsActive, setMenuSettingsActive] = useState(true);
  const [isMyProfileActive, setIsMyProfileActive] = useState(false);
  const [isSettingsActive, setIsSettingsActive] = useState(false);
  const [isAvailListActive, setIsAvailListActive] = useState(false);
  const [isContactActive, setIsContactActive] = useState(false);
  const [isSchedActive, setIsSchedActive] = useState(false);
  const [isHelpActive, setIsHelpActive] = useState(false);
  const [isAboutActive, setIsAboutActive] = useState(false);
  const [isShowAlert, setIsShowAlert] = useState(false);
  const [isEMTUser, checkEMTUser]: any = useState(false);
  const [activeUserMenuList, setActiveUserMenuList]: any = useState();

  const [isOnUSer,setIsOnUSer] = useState(false)
  const { t } = useTranslation("menu");
  const { t: tHeader } = useTranslation("header");

  useEffect(() => {
    loggedInUserService.loggedInUserData.subscribe((data: any) => {
      setIsOnUSer(data?.userData?.roleBasedPermission?.isOnUser)
    });
  }, [])

  useLayoutEffect(() => {
    loggedInUserService.loggedInUserData.subscribe((data: any) => {
      let isemtUser = checkIsEMTUser(data?.userData);
      checkEMTUser(isemtUser);
      setMenuList();
      setMenuSettingsList();
    });
  });

  useEffect(() => {
    if (props.isMyContactNumberClicked) {
      openCardItemOnClick(CONSTANTS.MENU_SETTINGS_LIST_ITEMS.MY_CONTACT_NUMBER);
    }
  }, [props.isMyContactNumberClicked]);

  // subscrption when settings icon is clicked to return to  the main menu
  useEffect(() => {
    let sub = settingsService.setMainMenuPage.subscribe((data: any) => {
      if (data) {
        onCancelClick();
      }
    });
    return () => {
      sub.unsubscribe();
    };
  });

  const checkIsEMTUser = (loggedInUser: any): any => {
    if (loggedInUser) {
      return loggedInUser.roles.some(function (item: any) {
        return item.name === CONSTANTS.ROLES.EMT;
      });
    }
  };

  const setMenuList = () => {
    if (isEMTUser) {
      setActiveUserMenuList(emsMenuSettingsConstants);
    } else {
      if(isOnUSer){
        setActiveUserMenuList(ONmenuSettingsConstants);
      } else {
        setActiveUserMenuList(menuSettingsConstants);
      }
      // setActiveUserMenuList(menuSettingsConstants);
    }
  };

  const setMenuSettingsList = () => {
    if (utilService.getScreenSize() === "large") {
      _.remove(activeUserMenuList, {
        menuId: CONSTANTS.MENU_SETTINGS_LIST_ITEMS.LOG_OUT,
      });
    }
  };

  const logout = () => {
    AuthService.logout();
  };

  const openCardItemOnClick = (id: any) => {
    setMenuSettingsActive(false);
    props.isInactive();

    // changed if else to switch case
    switch (id) {
      case CONSTANTS.MENU_SETTINGS_LIST_ITEMS.MY_PROFILE:
        setIsMyProfileActive(true);
        break;
      case CONSTANTS.MENU_SETTINGS_LIST_ITEMS.SETTINGS:
        setIsSettingsActive(true);
        break;
      case CONSTANTS.MENU_SETTINGS_LIST_ITEMS.AVAILABILITY_LIST:
        setIsAvailListActive(true);
        break;
      case CONSTANTS.MENU_SETTINGS_LIST_ITEMS.MY_CONTACT_NUMBER:
        setIsContactActive(true);
        break;
      case CONSTANTS.MENU_SETTINGS_LIST_ITEMS.SCHEDULE_SYNC:
        setIsSchedActive(true);
        break;
      case CONSTANTS.MENU_SETTINGS_LIST_ITEMS.HELP:
        setIsHelpActive(true);
        break;
      case CONSTANTS.MENU_SETTINGS_LIST_ITEMS.ABOUT_US:
        setIsAboutActive(true);
        break;
      case CONSTANTS.MENU_SETTINGS_LIST_ITEMS.LOG_OUT:
        setIsShowAlert(true);
        onCancelClick();
        break;
    }
  };

  const onCancelClick = () => {
    setAllInactive();
    setMenuSettingsActive(true);
    props.isActive();
  };

  const setAllInactive = () => {
    setIsMyProfileActive(false);
    setIsSettingsActive(false);
    setIsAvailListActive(false);
    setIsContactActive(false);
    setIsSchedActive(false);
    setIsHelpActive(false);
    setIsAboutActive(false);
    // setIsHeaderActive(true);
  };

  return (
    <div className="settings-list">
      <IonAlert
        isOpen={isShowAlert}
        onDidDismiss={() => {
          setIsShowAlert(false);
          onCancelClick();
        }}
        cssClass="header-sign-off-alert"
        header={tHeader("confirmationMessage")}
        message={tHeader("confirmationMessage")}
        buttons={[
          {
            text: tHeader("no"),
            handler: () => {
              onCancelClick();
            },
            role: "cancel",
            cssClass: "secondary",
          },
          {
            text: tHeader("yes"),
            handler: () => {
              logout();
            },
          },
        ]}
      />
      {isMenuSettingsActive
        ? [
            <div>
              <div className="main-menu-card">
                {activeUserMenuList &&
                  activeUserMenuList.map((item: any) => {
                    return (
                      <div
                        className="menu-settings-card-wrapper"
                        onClick={() => openCardItemOnClick(item.menuId)}
                      >
                        <IonLabel>
                          <span className="icon-color">
                            <span className={item.menuIcon}></span> {""}
                          </span>
                          {t(item.menuName)}
                        </IonLabel>
                      </div>
                    );
                  })}
              </div>
            </div>,
          ]
        : [
            <div>
              {isMyProfileActive && (
                <MyProfile onCancel={onCancelClick}></MyProfile>
              )}
              {isSettingsActive && (
                <Settings onCancel={onCancelClick}></Settings>
              )}
              {isAvailListActive && (
                <AvailabilityList onCancel={onCancelClick}></AvailabilityList>
              )}
              {isContactActive && (
                <ContactNum onCancel={onCancelClick}></ContactNum>
              )}
              {isSchedActive && (
                <ScheduleSync onCancel={onCancelClick}></ScheduleSync>
              )}
              {isHelpActive && <Help onCancel={onCancelClick}></Help>}
              {isAboutActive && <About onCancel={onCancelClick}></About>}
              {/* {isSignOffActive && (
              
              )} */}
            </div>,
          ]}


    </div>
  );
};
export default MenuSettingsList;
